function componentDrawer() {
  const mainContent = document.querySelector('#MainContent');
  const body = document.querySelector('body');

  document.querySelectorAll('.drawer-button').forEach((button) => {
    button.addEventListener('click', (event) => {
      event.stopPropagation();
      toggleDrawer(button.nextElementSibling.closest('.drawer-container'));
      body.classList.add('drawer-open');
    });

    button.nextElementSibling.querySelector('.drawer-overlay').addEventListener('click', (e) => {
      const targetClassList = e.target.classList.value;
      if (targetClassList === 'drawer-overlay' || targetClassList === 'icon icon-close') {
        toggleDrawer(button.nextElementSibling.closest('.drawer-container'));
      }
    });
  });

  document.querySelectorAll('.drawer-container .drawer__header > svg').forEach((closeButton) => {
    closeButton.addEventListener('click', (event) => {
      closeDrawer(closeButton.closest('.drawer-container.open'));
      event.stopImmediatePropagation();
    });
  });

  const toggleDrawer = (drawerWrapper) => {
    if (!drawerWrapper.classList.contains('open')) {
      closeOtherDrawers(drawerWrapper);
    }
    drawerWrapper.classList.toggle('open');
    mainContent.classList.toggle('drawer-open');
    body.classList.toggle('drawer-open');

    drawerWrapper.addEventListener('touchmove', (event) => {
      event.target.querySelectorAll('input').forEach((input) => {
        input.blur();
      });
      if (event.target.classList.contains('drawer-overlay')) {
        event.preventDefault();
      }
    });
    drawerWrapper.querySelector('.drawer__content').addEventListener('scroll', (event) => {
      event.target.querySelectorAll('input').forEach((input) => {
        input.blur();
      });
    });
  };

  const closeDrawer = (drawerWrapper) => {
    drawerWrapper.classList.remove('open');
    mainContent.classList.remove('drawer-open');
    body.classList.remove('drawer-open');
  };

  const closeOtherDrawers = (currentDrawer) => {
    document.querySelectorAll('.drawer-container.open').forEach((drawerContainer) => {
      if (drawerContainer !== currentDrawer) {
        drawerContainer.classList.remove('open');
      }
      mainContent.classList.remove('drawer-open');
    });
  };
}

// Run when the document is fully loaded
document.addEventListener('DOMContentLoaded', componentDrawer);

// Run when the modal opens
document.addEventListener('modalOpened', componentDrawer);
